import { theme } from '~/styles';
import { CSSProperties } from 'react';
import { State } from 'react-select/base';

const selectStyles = {
  container: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    fontFamily: theme.fonts.objectSans,
    fontWeight: 500,
  }),
  control: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    backgroundColor: theme.colors.primary.white,
    height: '38px',
    borderColor: theme.colors.primary.darkBlue,
    paddingLeft: '13px',
    cursor: 'pointer',
    boxShadow: 'none',
    borderRadius: '8px',
  }),
  valueContainer: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    borderRight: 'none',
    padding: 0,
  }),
  indicatorSeparator: (): CSSProperties => ({
    display: 'none',
  }),
  indicatorsContainer: (styles: CSSProperties, state: State): CSSProperties => ({
    ...styles,
    position: 'relative',
    zIndex: 10,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),
  placeholder: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    margin: 0,
  }),
  singleValue: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    margin: 0,
    color: theme.colors.primary.darkBlue,
  }),
  menu: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    margin: 0,
    padding: 0,
    top: 0,
    background: theme.colors.primary.white,
    border: `1px solid ${theme.colors.primary.navy}`,
    cursor: 'pointer',
    borderRadius: '8px',
  }),
  menuList: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    padding: '2px 0',
  }),
  option: (styles: CSSProperties, { isDisabled, isSelected }: State): CSSProperties => {
    return {
      ...styles,
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      background: 'none',
      color: theme.colors.primary.darkBlue,
      fontFamily: theme.fonts.objectSans,
      fontWeight: isSelected ? 700 : 200,
      paddingLeft: '13px',
    };
  },
};

export default selectStyles;
